import React from "react";
import FormGroup from "../FormGroup";
import { FieldGrid, SectionHeading } from "../FieldGrid";
import { QuestionairePassedThroughProps, QuestionType } from "../types";

const QuestionsMain = (props: QuestionairePassedThroughProps) => {
  const { questionsMain, setQuestionsMain } = props;

  const onFieldChange = (id: string) => (evnt: any) => {
    const { value } = evnt.target;
    const questionsWithValue: QuestionType[] = questionsMain.map((question) => {
      const sameQuestion = question.id === id;
      if (sameQuestion) {
        question.value = value;
        question.invalid = value === "";
      }
      return question;
    });
    setQuestionsMain(questionsWithValue);
  };

  const renderField = (q: QuestionType) => (
    <FormGroup
      key={q.id}
      value={q.value}
      id={q.id}
      displayValue={q.displayValue}
      hint={q.hint}
      required={q.required}
      type={q.type}
      placeholder={q.placeholder}
      feedbackInvalid={q.feedbackInvalid}
      invalid={q.invalid}
      wide={q.wide}
      onChangeEvent={onFieldChange(q.id)}
    />
  );

  // Collect fields into ordered groups (consecutive fields sharing `group`).
  const groups: Array<{ name: string; items: QuestionType[] }> = [];
  (questionsMain || []).forEach((q) => {
    const name = q.group || "";
    const last = groups[groups.length - 1];
    if (last && last.name === name) {
      last.items.push(q);
    } else {
      groups.push({ name, items: [q] });
    }
  });

  return (
    <>
      {groups.map((group) => (
        <React.Fragment key={group.name || "ungrouped"}>
          {group.name ? <SectionHeading>{group.name}</SectionHeading> : null}
          <FieldGrid>{group.items.map(renderField)}</FieldGrid>
        </React.Fragment>
      ))}
    </>
  );
};

export default QuestionsMain;
